import React from "react";
import { View } from "react-native";
import deleteIcon from "@/assets/delete-icon.png";
import { removeItemStyles as styles } from "./styles";
import TposButton from "../../Buttons/TposButton";
import { TposIcon } from "../../Icons/TposIcon";
import { useTranslateText } from "@/app/utils/translations";

type RemoveItemProps = {
  onDeletePress: () => void;
};
const RemoveItem = ({ onDeletePress }: RemoveItemProps): JSX.Element => {
  const { t } = useTranslateText();
  const removeItemText = t("tpos.productArea.removeItem");

  return (
    <View style={styles.buttonContainer}>
      <TposButton
        styles={{
          buttonText: styles.removeText,
          buttonContainer: styles.button,
        }}
        onPress={onDeletePress}
        buttonText={removeItemText}
        accessibilityLabel={removeItemText}
        accessibilityHint="Removes this item from the basket"
        testID="remove-item-button"
      >
        <TposIcon icon={deleteIcon} />
      </TposButton>
    </View>
  );
};

export default RemoveItem;
